import React from "react"
import { Modal } from "components/views/modal/Modal"
import styled from "styled-components"
import { HR } from "components/views/atoms/Atoms"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type CarrotPlansTourModal = {
  onExit: () => void
}

const TourTitle = styled.h1.attrs({ className: "black-80" })`
  font-family: Publico Headline;
  font-size: 32px;
  line-height: 150%;
`
const TourContainer = styled.div`
  padding: 0px 48px 33px;
`
const TourText = styled.p.attrs({ className: "black-80" })`
  margin: 31px 0 16px 0;
  line-height: 150%;
`

const TourImage = styled.img`
  margin-bottom: 31px;
  border-radius: 4px;
`

export default function CarrotPlansTourModal({ onExit }: CarrotPlansTourModal): JSX.Element {
  return (
    <Modal titleText={l`carrotPlans.tour.title`} onExit={onExit} underlayClickExits={true}>
      <TourContainer>
        <TourTitle>{l`carrotPlans.tour.title`}</TourTitle>
        <TourText> {l`carrotPlans.tour.menuItem`} </TourText>
        <TourImage alt="menu-item" src="/images/carrot-plans/menu-item@2x.png" />
        <HR color={"black-20"} />
        <TourText> {l`carrotPlans.tour.checkbox`} </TourText>
        <TourImage alt="menu-item" src="/images/carrot-plans/checkbox@2x.png" />
        <HR color={"black-20"} />
        <TourText> {l`carrotPlans.tour.notRelevant`} </TourText>
        <TourImage alt="menu-item" src="/images/carrot-plans/not-relevant@2x.png" />
      </TourContainer>
    </Modal>
  )
}
